
import authService, { decodeToken } from 'core/auth/auth-service'
import { ACCESS_TOKEN_KEY } from 'core/auth/constants'
import { useEffect, useRef } from 'react'

export default function IdleMonitor(): null {
  let idleRef = useRef(0).current;
  const token: any = localStorage.getItem(ACCESS_TOKEN_KEY)

  useEffect(() => {
    const decodedUser = decodeToken<{ exp: number, iat: number }>(token)
    if (!decodedUser) {
      return
    }

    const idleInterval = setInterval(timerIncrement, 1000)
    const maxTimeUserInactivity = (decodedUser.exp - decodedUser.iat) * 1000;

    function timerIncrement() {
      idleRef += 1;
      if (idleRef > maxTimeUserInactivity) {
        authService.signOut();
        clearInterval(idleInterval);
      }
    }
    
    function resetIdleRef() {
      idleRef = 0;
    }

    if(token) {
      document.body.addEventListener('mousemove', resetIdleRef)
      document.body.addEventListener('keypress', resetIdleRef)
      document.body.addEventListener('onload', resetIdleRef)
      document.body.addEventListener('onmousemove', resetIdleRef)
      document.body.addEventListener('onmousedown', resetIdleRef)
      document.body.addEventListener('ontouchstart', resetIdleRef)
      document.body.addEventListener('ontouchmove', resetIdleRef)
      document.body.addEventListener('onclick', resetIdleRef)
      document.body.addEventListener('onkeydown', resetIdleRef)
      document.body.addEventListener('scroll', resetIdleRef, true)
    }

    return () => {
      document.body.removeEventListener('mousemove', resetIdleRef);
      document.body.removeEventListener('keypress', resetIdleRef);
      document.body.removeEventListener('onload', resetIdleRef)
      document.body.removeEventListener('onmousemove', resetIdleRef)
      document.body.removeEventListener('onmousedown', resetIdleRef)
      document.body.removeEventListener('ontouchstart', resetIdleRef)
      document.body.removeEventListener('ontouchmove', resetIdleRef)
      document.body.removeEventListener('onclick', resetIdleRef)
      document.body.removeEventListener('onkeydown', resetIdleRef)
      document.body.removeEventListener('scroll', resetIdleRef, true)
      clearInterval(idleInterval);
    }
  }, [token]);

  return null;
}